var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ([6, 7, 16, 11, 17].includes(this.deliveryId))?_c('div',{class:_vm.isSignature && 'signature-history',attrs:{"id":"signatureError"}},[_c('img',{attrs:{"src":_vm.imageError,"alt":"image-signature-error"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }